// Safe-area helper — Phase 12 Plan 12-00 (RESEARCH Pitfall 1, telegram-ui bug #93).
//
// На iPhone 12 (notch / home-indicator) фиксированные нижние бары (Tabbar,
// bottom-CTA) обязаны иметь нижний зазор, иначе их перекрывает home-indicator.
//
// Telegram SDK предоставляет `viewportSafeAreaInsetBottom`, НО у telegram-ui /
// SDK есть известный баг (#93): это значение обнуляется (→ 0) после
// input-focus + back на iPhone. Поэтому НЕ полагаемся только на SDK-значение.
//
// Стабильный fallback — CSS `env(safe-area-inset-bottom)`, который браузер
// WebView вычисляет нативно из device-geometry и не сбрасывает. Берём `max()`
// от SDK-значения и CSS env, чтобы получить корректный зазор в обоих случаях.

/**
 * Минимальный гарантированный нижний зазор в px, когда `env(safe-area-inset-bottom)`
 * и SDK-значение оба равны 0 (не-notch устройства / desktop). Держит Tabbar
 * визуально отделённым от края экрана.
 */
export const SAFE_AREA_BOTTOM_FALLBACK_PX = 8;

/**
 * CSS-значение для `padding-bottom` нижних фиксированных баров.
 *
 * `max(env(safe-area-inset-bottom), {sdkValue}px, {fallback}px)`:
 *   - `env(safe-area-inset-bottom)` — стабильный CSS-fallback (Pitfall 1, не сбрасывается);
 *   - `{sdkValue}px` — опциональное SDK-значение (если передано и валидно);
 *   - `{fallback}px` — минимальный зазор на устройствах без notch.
 *
 * @param sdkSafeAreaBottomPx необязательное SDK-значение `viewportSafeAreaInsetBottom`.
 *   Может быть `undefined` (вне Telegram / dev) или `0` (после бага #93).
 */
export function safeAreaBottomPadding(sdkSafeAreaBottomPx?: number): string {
  const parts = ["env(safe-area-inset-bottom)"];
  if (
    typeof sdkSafeAreaBottomPx === "number" &&
    Number.isFinite(sdkSafeAreaBottomPx) &&
    sdkSafeAreaBottomPx > 0
  ) {
    parts.push(`${sdkSafeAreaBottomPx}px`);
  }
  parts.push(`${SAFE_AREA_BOTTOM_FALLBACK_PX}px`);
  return `max(${parts.join(", ")})`;
}

/**
 * Готовая константа для общего случая (без SDK-значения) — использует только
 * CSS `env()` + статический fallback. Подходит для Tabbar и bottom-bar layouts,
 * где SDK-значение либо недоступно, либо ненадёжно (баг #93).
 */
export const SAFE_AREA_BOTTOM = safeAreaBottomPadding();
